import { IUserAuthReturn, useProvider } from 'contexts/AuthContext';

export default function useAuth(): IUserAuthReturn {
  const authData = useProvider();
  return authData;
}
